module.exports = __webpack_public_path__ + "static/img/PEUGEOT.cbf2a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/PEUGEOT.png
// module id = V6CW
// module chunks = 1